// framework
import React from "react";
// assets
import { IMAGES } from "constants/constants";
// styles
import styles from "./WaitingView.module.scss";
import Player from "components/Shared/Player/Player";

export default function WaitingView({ player, room, text = "Waiting for game..." }) {
    return (
        <div className={styles.waitingView}>
            {/*<img src={IMAGES.CLIENT.mdmdLogo} alt="Million Dollar Money Drop" className={styles.logo} />*/}
            <Player className={styles.player} player={player} room={room} />
            <div className={styles.content}>
                <h3 className={styles.message}>{text}</h3>
            </div>
        </div>
    );
}